module.exports = __webpack_public_path__ + "static/level-10.3b388811.png";